import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export const SHARE_OF_VOICE_EXCLUDE_OTHERS = "shareOfVoiceExcludeOthers";
export const SHARE_OF_VOICE_INCLUDE_OTHERS = "shareOfVoiceIncludeOthers";

export const granularityModulus = {
    [GranularityNames.DAILY]: 1,
    [GranularityNames.WEEKLY]: 7,
    [GranularityNames.MONTHLY]: 30,
};

export const REPORT_GRANULARITY_OPTIONS = [
    {
        title: "D",
        value: GranularityNames.DAILY,
        disabled: false,
    },
    {
        title: "W",
        value: GranularityNames.WEEKLY,
        disabled: false,
    },
    {
        title: "M",
        value: GranularityNames.MONTHLY,
        disabled: false,
    },
];
